export function formatSize(bytes: number): string {
    return (bytes / 1024).toFixed(2) + " KB";
}

export function validateFile(
    file: File,
    errorRef: any,
    allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'],
    maxSizeMB = 2
): boolean {
    if (!allowedTypes.includes(file.type)) {
        errorRef.value = "Invalid file type. Only JPG, PNG, and PDF are allowed.";
        return false;
    }
    if (file.size > maxSizeMB * 1024 * 1024) {
        errorRef.value = "File size exceeds 2MB limit.";
        return false;
    }
    return true;
}

export async function processFileUpload(
    file: File,
    uploadFn: Function,
    fileListRef: any,
    options?: {
        onSuccess?: () => void;
        onError?: (err: any) => void;
    }
) {
    const fileId = Date.now() + Math.random();
    fileListRef.value.push({
        uuid: fileId,
        name: file.name,
        size: formatSize(file.size),
        status: "progress",
        percent: 0,
    });

    try {
        // Upload file — uploadFn should return the real server UUID
        const serverUuid = await uploadFn(file, (progress: number) => {
            const index = fileListRef.value.findIndex(f => f.uuid === fileId);
            if (index !== -1) fileListRef.value[index].percent = progress;
        });
        const index = fileListRef.value.findIndex(f => f.uuid === fileId);
        if (index !== -1) {
            fileListRef.value[index].uuid = serverUuid; // passes the correct uuid from the server
            fileListRef.value[index].status = "uploaded";
            fileListRef.value[index].percent = 100;
        }
        options?.onSuccess?.();
    } catch (err) {
        const index = fileListRef.value.findIndex(f => f.uuid === fileId);
        if (index !== -1) fileListRef.value[index].status = "failed";
        options?.onError?.(err);
    }
}